import { useDispatch } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import loadSignedInContext from '@/redux/actions/sessionActions/loadSignedInContext.js';
import { acceptMemberInvite } from '@/redux/requests/sessionRequests.js';
import AuthLayout from '../components/AuthLayout.jsx';
import AuthNotice from '../components/AuthNotice.jsx';
import NewPasswordForm from '../components/NewPasswordForm.jsx';
import describeAuthFailure from '../lib/describeAuthFailure.js';

/** Turns an emailed invitation into an account: the person sets a password and lands in the inviting organization. */
const AcceptInvitePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const handleSubmit = async ({ password, name }) => {
    const res = await acceptMemberInvite({ token, password, name });

    if (res?.success === false) {
      return describeAuthFailure(res);
    }

    await dispatch(loadSignedInContext({ companyId: res?.user?.companyId }));
    navigate('/', { replace: true });
    return null;
  };

  return (
    <AuthLayout
      title="Join your team on Pieve"
      description="Set a password to accept the invitation. You will land in the organization that invited you."
      footer={
        <>
          Already set a password?{' '}
          <Link className="auth-link" to="/sign-in">
            Sign in
          </Link>
        </>
      }>
      {token ? <NewPasswordForm submitLabel="Accept invitation" askName onSubmit={handleSubmit} /> : <AuthNotice>This invitation link is missing its code. Open the link from the email again.</AuthNotice>}
    </AuthLayout>
  );
};

export default AcceptInvitePage;
